import { render } from "./BadgesPage.vue?vue&type=template&id=c47dd544&ts=true"
import script from "./BadgesPage.vue?vue&type=script&lang=ts"
export * from "./BadgesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__